import { RsuiteTab, RsuiteTabs } from "@components/adapters/rsuite/Tabs";
import type {
  TabProps,
  TabsComponent,
  TabsProps,
} from "@components/contracts/Tabs.types";

const Tab: React.FC<TabProps> = (props) => <RsuiteTab {...props} />;

export const Tabs: TabsComponent = Object.assign(
  (props: TabsProps) => <RsuiteTabs {...props} />,
  { Tab }
);

export type { TabProps, TabsProps };
